import { theme } from '../../../tailwind.config';

export const optionToHtml = (
  id: string,
  name: string,
  email: string
) => `<span id="mention" style="width: 100%; height: 100%; padding: 3px; background: ${
  theme.colors['blue-10']
}; border-radius: 4px;" class="non-editable" data-user-id="${id}">
          <span id="mention-name" style="color: ${
            theme.colors['bright-sky-blue']
          }; font-size: 15px; font-family: 'PT Sans', sans-serif; font-weight: 400; text-transform: capitalize; word-wrap: break-word">@${name} </span>
          <span style="color: ${
            theme.colors['bright-sky-blue']
          }; font-size: 15px; font-family: 'PT Sans', sans-serif; font-style: italic; font-weight: 400; text-transform: capitalize; word-wrap: break-word">
          (<span id="mention-email" style="color: ${
            theme.colors['bright-sky-blue']
          }; font-size: 15px; font-family: 'PT Sans', sans-serif; font-style: italic; font-weight: 400; text-transform: lowercase; word-wrap: break-word">${email}</span>)</span>
</span>${' '}`;
